import { finish, error } from '../../../modules/transactions/actions/assign';
import api from '../../../api';

export function request(dispatch, { accountId, id }) {
    api.post('/transactions/' + accountId + '/' + id + '/assignee').then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
